<template lang="pug">
  div.info.warning
    font-awesome-icon.bell(icon="bullhorn", size="lg")
    label.text {{message}}
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="stylus" scoped>
@import "../../assets/styles/variables.styl"
.info
  width 100%
  padding 20px
  text-align center

  svg
    margin-right 10px


.warning
  background-color $warning-color
  color $cyprus-color

</style>



// WEBPACK FOOTER //
// src/components/layout-components/Notification.vue